<template>
    <card-skeleton data-id="orderHistoryCard" class-name="bg-white hover-card pb-2 pt-2 rounded-0">
        <v-card-item class="pa-0">
            <div class="d-flex justify-space-between align-items-start">
                <order-history-card-details
                    :order-line-title="orderLineItem.title"
                    :order-line-zones="orderLineItem.zones"
                    :is-ticket="isOrderTypeTicket(orderLineItem.productType)"
                />
                <order-history-card-action :order-id="orderId" :language="language" />
            </div>
            <div class="d-flex justify-space-between align-center">
                <order-history-card-meta
                    :created-at="createdAt"
                    :travel-card-name="emptyValueFallback(orderLineItem?.travelCard?.name)"
                    :travel-card-id="emptyValueFallback(orderLineItem?.travelCard?.id)"
                    :is-ticket="isOrderTypeTicket(orderLineItem.productType)"
                    :order-line-zones="orderLineItem.zones"
                    :is-all-zones="orderLineItem.isAllZones"
                />
                <order-history-card-price :price="orderLineItem.price" />
            </div>
        </v-card-item>
        <v-divider v-if="!isLast" :thickness="2" class="mt-4"></v-divider>
    </card-skeleton>
</template>

<script setup lang="ts">
import OrderHistoryCardAction from './OrderHistoryCardAction.vue';
import OrderHistoryCardMeta from './OrderHistoryCardMeta.vue';
import OrderHistoryCardPrice from './OrderHistoryCardPrice.vue';
import OrderHistoryCardDetails from './OrderHistoryCardDetails.vue';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';
import { IOrderHistoryCard } from '../../types';
import { emptyValueFallback } from '@/helpers';
import { isOrderTypeTicket } from '../../helpers';

defineProps<IOrderHistoryCard>();
</script>
